import { Modal, ModalBody, ModalElement } from 'kl-b2c-ui-kit';
import React, { PropsWithChildren, forwardRef } from 'react';

const PrimaryModal = forwardRef<ModalElement, PropsWithChildren & { maxWidth?: string; atSelector: string }>(
    ({ children, maxWidth, atSelector }, ref) => (
        <Modal
            ref={ref}
            size={'md'}
            showClose
            atSelector={atSelector}
            styles={{
                borderRadius: '16px',
                top: '50%',
                maxWidth: maxWidth ?? '1024px',
                transform: 'translateY(-50%)',
                '@media screen and (max-width: 767px)': {
                    borderRadius: 'initial',
                },
            }}
        >
            <ModalBody
                styles={{
                    padding: '32px 24px',
                    '@media screen and (max-width: 767px)': {
                        padding: '50px 16px 32px',
                    },
                }}
                data-at-selector={'directionsModalBody'}
            >
                {children}
            </ModalBody>
        </Modal>
    )
);

export default PrimaryModal;
